import { SentimentName } from 'v2/core/entities/fields';
import { UUID } from 'v2/core/entities/uuid';

export const segregateEntitySentimentPair = (
  str: string,
): [SentimentName, UUID] => {
  return Object.values(JSON.parse(str)) as [SentimentName, UUID];
};

export const joinEntitySentimentPair = (
  sentiment: SentimentName,
  entity: UUID,
): string => JSON.stringify({ sentiment, entity });
